<div class="flex-spacer"></div>
<button mat-raised-button (click)="resetForm()" *ngIf="contractService.form.dirty"><mat-icon>undo</mat-icon>Revert</button>
<button mat-raised-button (click)="location.back()" *ngIf="!contractService.form.dirty"><mat-icon>arrow_left</mat-icon>Back</button>
<button mat-raised-button color="primary" (click)="createContract()" [disabled]="!contractService.form.dirty">Save</button>
